'use client';

import React from 'react';
import Image from 'next/image';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import ContentVideoActions from './ContentVideoActions';

import { Heading } from '@/components/design/heading';
import VideoModal from '@/components/design/videoModal';
import useTranslation from '@/hooks/useTranslation';
import PlayCircleIcon from '@/svgs/playCircle.svg';
import VideoIcon from '@/svgs/video.svg';

type Props = {
  link: string;
  cover: string;
};

const ContentVideo: React.FC<Props> = ({ link, cover }) => {
  const { t } = useTranslation('pages.content');

  const searchParams = useSearchParams();
  const isModalOpen =
    searchParams.get('isModalOpen') && searchParams.get('isModalOpen') === link;
  const pathname = usePathname();
  const router = useRouter();

  const toggleVideoModal = () => {
    if (isModalOpen) {
      router.back();
    } else {
      router.push(`${pathname}?isModalOpen=${link}`);
    }
  };

  return (
    <div>
      {isModalOpen && (
        <VideoModal
          video_url={link}
          isOpen={isModalOpen}
          onCloseModal={toggleVideoModal}
        />
      )}
      <div className="flex flex-col gap-4 relative hover:cursor-pointer">
        <Heading title={t('video')} icon={<VideoIcon />} />
        <div
          className="rounded-md overflow-hidden relative"
          onClick={toggleVideoModal}
        >
          <div className="absolute bg-linear-gradient-2 w-full h-full"></div>
          <Image
            src={cover}
            alt="Video Cover"
            layout="responsive"
            width={335}
            height={160}
          />
          <PlayCircleIcon className="w-[29px] h-[29px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
        </div>
        <div className="flex w-full h-11 justify-between items-center absolute bottom-0 right-0 p-1.5 z-10">
          <ContentVideoActions video_link={link} />
        </div>
      </div>
    </div>
  );
};

export default ContentVideo;
